export const entityEventStatusMixin = {
  methods: {
    getStatus (status) {
      const statusIcons = {
        CREATED: {
          title: 'Task created',
          image: 'mdi-plus-circle-outline',
          color: 'blue'
        },
        FAILED: {
          title: 'Task failed',
          image: 'mdi-alert-circle-outline',
          color: 'red'
        },
        STARTED: {
          title: 'Task started',
          image: 'mdi-progress-clock',
          color: 'orange'
        },
        COMPLETED: {
          title: 'Task completed',
          image: 'mdi-check-circle-outline',
          color: 'green'
        },
        DEFERRED: {
          title: 'Task deferred',
          image: 'mdi-pause-circle-outline',
          color: 'orange'
        }
      }
      return statusIcons[status] || {}
    }
  }
}
